// Trident (Neptune): a constellation with exactly three branches scores more.
import { ALIGNMENT_NUMBERS as N } from '../constants';
import { branches } from '../shared/branches';
import type { AlignmentDef } from '../types';

export const trident: AlignmentDef = {
  id: 'trident',
  planet: 'neptune',
  name: 'Trident',
  text: () => `Constellations with exactly ${N.tridentBranches === 3 ? 'three' : N.tridentBranches} branches score +${N.tridentPercent}%.`,
  wordPercent: (c) => (branches(c) === N.tridentBranches ? N.tridentPercent : 0),
};
